var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component, Prop } from 'vue-property-decorator';
import linker from '../linker';
var DocumentLookupField = (function (_super) {
    __extends(DocumentLookupField, _super);
    function DocumentLookupField() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.items = [];
        return _this;
    }
    DocumentLookupField.prototype.mounted = function () {
        this.load();
    };
    DocumentLookupField.prototype.load = function () {
        var _a;
        (_a = this.items).push.apply(_a, this.getValues());
    };
    DocumentLookupField.prototype.getHiddenInput = function () {
        return document.getElementById(this.hiddenInputId);
    };
    DocumentLookupField.prototype.getValues = function () {
        return JSON.parse(this.getHiddenInput().value).map(function (i) {
            var parts = i.ServerRelativeUrl.split('/');
            i.Filename = parts[parts.length - 1];
            return i;
        });
    };
    DocumentLookupField.prototype.saveValues = function () {
        this.getHiddenInput().value = JSON.stringify(this.items);
    };
    DocumentLookupField.prototype.remove = function (item) {
        var index = this.items.findIndex(function (i) { return i.ID == item.ID; });
        if (index > -1) {
            this.items.splice(index, 1);
        }
        this.saveValues();
    };
    DocumentLookupField.prototype.move = function (item, dir) {
        var index = this.items.findIndex(function (i) { return i.ServerRelativeUrl == item.ServerRelativeUrl; });
        if (index > -1) {
            if (dir < 0) {
                if (index > 0) {
                    this.items.splice(index, 1);
                    this.items.splice(index - 1, 0, item);
                }
            }
            else {
                if (index < this.items.length - 1) {
                    this.items.splice(index, 1);
                    this.items.splice(index + 1, 0, item);
                }
            }
        }
        this.saveValues();
    };
    DocumentLookupField.prototype.openPicker = function () {
        var _this = this;
        this.openModal(this.listUrl, this.webId, this.listId, function (assetUrl) {
            _this.loadItemByServerRelativeUrl(assetUrl).then(function (asset) {
                if (!assetUrl.toLowerCase().startsWith(_this.listUrl.toLowerCase())) {
                    _this.items.push({
                        ID: 0,
                        Title: "Ein Verweis auf eine andere Bibliothek kann nicht gespeichert werden: " + asset.filename,
                        ServerRelativeUrl: asset.serverRelativeUrl,
                        Filename: asset.filename,
                    });
                    _this.saveValues();
                    return;
                }
                if (!asset.title) {
                    _this.items.push({
                        ID: 0,
                        Title: "Ein Verweis ohne Titel kann nicht gespeichert werden: " + asset.filename,
                        ServerRelativeUrl: asset.serverRelativeUrl,
                        Filename: asset.filename,
                    });
                    _this.saveValues();
                    return;
                }
                if (_this.items.findIndex(function (i) { return i.ID === asset.id; }) === -1) {
                    _this.items.push({
                        ID: asset.id,
                        Title: asset.title,
                        ServerRelativeUrl: asset.serverRelativeUrl,
                        Filename: asset.filename,
                    });
                    _this.saveValues();
                }
            });
        });
    };
    DocumentLookupField.prototype.openModal = function (listServerRelativeUrl, webId, listId, cb) {
        var opts = {
            title: 'Dokumentenauswahl',
            url: _spPageContextInfo.siteAbsoluteUrl + "/_layouts/15/RUB/CustomRibbon/RubAssetPortalBrowser.aspx?&AssetUrl=" + listServerRelativeUrl + "&RootFolder=" + listServerRelativeUrl + "&MDWeb=" + webId + "&List=" + listId + "&AssetType=Link&rubForm=1",
            showMaximized: true,
            autoSize: true,
            dialogReturnValueCallback: function (args, value) {
                if (args === 1) {
                    cb(value.AssetUrl);
                }
            },
        };
        SP.UI.ModalDialog.showModalDialog(opts);
    };
    DocumentLookupField.prototype.loadItemByServerRelativeUrl = function (assetUrl) {
        return $.ajax({
            url: _spPageContextInfo.siteAbsoluteUrl + "/_api/web/GetFileByServerRelativeUrl('" + assetUrl + "')/ListItemAllFields?$select=Id,Title,FileLeafRef",
            method: 'GET',
            headers: {
                accept: 'application/json; odata=verbose',
            },
        }).then(function (response) {
            var data = response.d;
            return {
                id: parseInt(data.Id || data.ID || 0),
                title: data.Title,
                filename: data.FileLeafRef,
                serverRelativeUrl: assetUrl
            };
        });
    };
    __decorate([
        Prop({ type: String })
    ], DocumentLookupField.prototype, "hiddenInputId", void 0);
    __decorate([
        Prop({ type: String })
    ], DocumentLookupField.prototype, "listUrl", void 0);
    __decorate([
        Prop({ type: String })
    ], DocumentLookupField.prototype, "webId", void 0);
    __decorate([
        Prop({ type: String })
    ], DocumentLookupField.prototype, "listId", void 0);
    DocumentLookupField = __decorate([
        Component({})
    ], DocumentLookupField);
    return DocumentLookupField;
}(Vue));
export default DocumentLookupField;
linker.register('documentLookupField', DocumentLookupField);
